import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import MuiSnackbar from '@material-ui/core/Snackbar';

import IconWarning from 'components/icons/IconWarning';
import IconCheck from 'components/icons/IconCheck';
import IconInfoCircle from 'components/icons/IconInfoCircle';

const styles = theme => ({
  snackbarContentRoot: {
    flexWrap: 'nowrap',
    minWidth: 150,
    textAlign: 'center',
    minHeight: 60,
    height: 'auto',
  },
  snackbarContentRootIcon: {
    paddingLeft: 104,
  },
  snackbarContentMessage: {
    width: '100%',
  },
  snackbarContentMessageNowrap: {
    whiteSpace: 'nowrap',
  },
  snackbarContentAction: {
    whiteSpace: 'nowrap',
  },
  variantIcon: {
    display: 'flex',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: 80,
    alignItems: 'center',
    justifyContent: 'center',
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  },
  variantIconWarning: {
    backgroundColor: theme.palette.validation[500],
  },
  variantIconSuccess: {
    backgroundColor: theme.palette.active[500],
  },
  variantIconInfo: {
    backgroundColor: theme.palette.primary[500],
  },
  iconWarning: {
    width: 30,
    height: 28,
    color: theme.palette.common.white,
  },
  iconCheck: {
    width: 30,
    height: 23,
    color: theme.palette.common.white,
  },
  iconInfoCircle: {
    width: 27,
    height: 27,
    color: theme.palette.common.white,
  },
});

const Snackbar = ({
  variant,
  classes,
  nowrapMessage,
  message,
  ...otherProps
}) => (
  <MuiSnackbar
    {...otherProps}
    ContentProps={{
      variant: 'subheading',
      classes: {
        root: classNames(classes.snackbarContentRoot, {
          [classes.snackbarContentRootIcon]: variant !== 'default',
        }),
        message: classNames(classes.snackbarContentMessage, {
          [classes.snackbarContentMessageNowrap]: nowrapMessage,
        }),
        action: classes.snackbarContentAction,
      },
    }}
    message={(
      <div>
        {variant === 'warning' &&
          <div className={classNames(classes.variantIcon, classes.variantIconWarning)}>
            <IconWarning className={classes.iconWarning} />
          </div>
        }
        {variant === 'success' &&
          <div className={classNames(classes.variantIcon, classes.variantIconSuccess)}>
            <IconCheck className={classes.iconCheck} />
          </div>
        }
        {variant === 'info' &&
          <div className={classNames(classes.variantIcon, classes.variantIconInfo)}>
            <IconInfoCircle className={classes.iconInfoCircle} />
          </div>
        }
        {message}
      </div>
    )}
  />
);

Snackbar.propTypes = {
  variant: PropTypes.oneOf(['default', 'warning', 'success', 'info']),
  message: PropTypes.string.isRequired,
  nowrapMessage: PropTypes.bool,
  classes: PropTypes.shape({
    snackbarContentRoot: PropTypes.string.isRequired,
    snackbarContentRootIcon: PropTypes.string.isRequired,
    snackbarContentMessage: PropTypes.string.isRequired,
    snackbarContentAction: PropTypes.string.isRequired,
    variantIcon: PropTypes.string.isRequired,
    variantIconWarning: PropTypes.string.isRequired,
    variantIconSuccess: PropTypes.string.isRequired,
    variantIconInfo: PropTypes.string.isRequired,
    iconWarning: PropTypes.string.isRequired,
    iconCheck: PropTypes.string.isRequired,
    iconInfoCircle: PropTypes.string.isRequired,
  }).isRequired,
};

Snackbar.defaultProps = {
  variant: 'default',
  nowrapMessage: false,
};

export default withStyles(styles)(Snackbar);



// WEBPACK FOOTER //
// ./src/components/common/Snackbar.js